import { Button } from 'components';
import Text from 'components/Text';
import images from 'enum/Images';
import { withNamespaces } from 'react-i18next';

import classNames from './styles.module.scss';

const GhostCard = () => (
  <div className={classNames.ghostCard}>
    <div className={`${classNames.ghostBar} ${classNames.ghostBarShort}`} />
    <div className={`${classNames.ghostBar} ${classNames.ghostBarMed}`} />
    <div className={classNames.ghostPill} />
    <div
      className={`${classNames.ghostBar} ${classNames.ghostBarShort}`}
      style={{ marginBottom: 6 }}
    />
    <div className={classNames.ghostProgressTrack} />
    <div className={classNames.ghostBtn} />
  </div>
);

const ArrowIcon = () => (
  <svg width="18" height="18" fill="none" viewBox="0 0 20 20">
    <path
      d="M4 10h12M12 6l4 4-4 4"
      stroke="#CBD5E1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FuturePeriodPlaceholder = ({ t, onViewCurrentPeriod }) => {
  return (
    <div className={classNames.placeholderWrap}>
      <div className={classNames.ghostPipeline}>
        <GhostCard />
        <div className={classNames.ghostArrow}>
          <ArrowIcon />
        </div>
        <GhostCard />
        <div className={classNames.ghostArrow}>
          <ArrowIcon />
        </div>
        <GhostCard />
      </div>
      <div className={classNames.ghostOverlay}>
        <div className={classNames.iconBadge}>
          <img src={images.CALENDAR_GREEN_ICON} alt="" width="24" height="24" />
        </div>
        <Text variant="strong" size="sm" textAlign="center">
          {t('futurePeriodSelected')}
        </Text>
        <Text
          variant="p"
          size="sm"
          color="secondary"
          textAlign="center"
          style={{ maxWidth: '330px' }}
        >
          {t('futurePeriodDatesAppear')}
        </Text>
        {onViewCurrentPeriod && (
          <Button type="teal" size="sm" onClick={onViewCurrentPeriod}>
            {t('viewCurrentPeriod')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default withNamespaces()(FuturePeriodPlaceholder);
